const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 14 10)",
  stroke: "#0081CC"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 5.67931,
  height: 8.33353,
  transform: "matrix(1 0 0 -1 5.78906 27)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 4,
  height: 6,
  transform: "matrix(1 0 0 -1 21 21)",
  stroke: "#0081CC"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 4,
  height: 7,
  transform: "matrix(1 0 0 -1 21 32)",
  stroke: "#0081CC"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.083 23.2694C13.083 23.2694 13.083 23.2368 13.083 23.1716C13.083 23.1064 13.1171 23.0562 13.1853 23.0211H15.3698V21.8926L15.3771 20.764C15.4259 20.6988 15.4721 20.6662 15.516 20.6662C15.5793 20.6662 15.628 20.7039 15.6621 20.7791V23.0211H17.8393C17.9124 23.0613 17.9489 23.1114 17.9489 23.1716C17.9489 23.2318 17.9124 23.2819 17.8393 23.3221H15.6621V25.5641C15.6231 25.6343 15.5793 25.6694 15.5306 25.6694H15.516H15.5014C15.4429 25.6694 15.3991 25.6343 15.3698 25.5641V23.3221H13.1853C13.1171 23.287 13.083 23.2368 13.083 23.1716V23.2694Z",
  fill: "#0C2846",
  stroke: "#0C2846"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25 23H20V22H25V23Z",
  fill: "#0C2846",
  stroke: "#0C2846",
  strokeWidth: 0.5
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27 13H5V11H27V13Z",
  fill: "#0C2846"
});

const SvgEquationRadicalsFractions2 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationRadicalsFractions2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-radicals-fractions-2.9763e9fc.svg";
export { ForwardRef as ReactComponent };